// extracted by mini-css-extract-plugin
export default {"container":"_3VY81","list":"U_MBv","event":"_3XQpp","title":"_23ZKl","chevron":"_1vWVX","info":"_3s6b8","time":"jGhdK"};